import { useQuery } from "react-query";
import { getBusLicensePermitCount } from "../../../../actions/CarrierAgreementMgmt/BusinessLicensesAndPermits";

export const useBusLicensePermitCount = () => {
  const { data, isLoading, refetch } = useQuery(
    "useBusLicensePermitCount",
    getBusLicensePermitCount,
    {
      refetchOnWindowFocus: false,
    },
  );
  return { data, isLoading, refetch };
};
